import { Control, Controller, FieldErrors, UseFormSetValue } from 'react-hook-form'
import { Checkbox, Flex } from 'antd'
import { IScale } from '@/models'
import { Icon, Rate } from '@/components/ui'

interface IScaleQuestionProps {
  question: IScale
  control: Control<any, any>
  errors: FieldErrors<any>
  setValue: UseFormSetValue<any>
}

const ScaleQuestion = ({ question, control, errors, setValue }: IScaleQuestionProps) => {
  const mainAnswers = question?.answers?.filter((item) => !item?.is_additional)
  const additionalAnswers = question?.answers?.filter((item) => item?.is_additional)

  return (
    <Flex vertical gap={20}>
      <Controller
        name={`${question.id}.answer_uuid`}
        control={control}
        rules={{ required: { value: true, message: 'Выберите оценку' } }}
        render={({ field: { ref, ...field } }) => (
          <>
            <Rate
              {...field}
              name='answer_uuid'
              view='title'
              label={`Оцените от 0 до ${question.answers.length - 1}`}
              count={mainAnswers.length}
              question={{ ...question, answers: mainAnswers }}
              character={<Icon name='star' />}
              errors={errors[question.id]}
              prefixcls='rate-title-main'
            />
            {additionalAnswers?.map((item: any) => (
              <Checkbox
                {...field}
                key={item?.uuid}
                checked={field.value === item?.value}
                prefixCls='checkbox-scale'
                onChange={(e) => {
                  if (e.target.checked) setValue(`${question.id}.answer_uuid`, item?.value)
                }}
              >
                {item?.title}
              </Checkbox>
            ))}
          </>
        )}
      />

      {question?.answers?.some((item) => item?.title === 'Затрудняюсь ответить' && item?.value === 99) && (
        <Controller
          name={`${question.id}.answer_uuid`}
          control={control}
          render={({ field }) => (
            <Checkbox
              {...field}
              checked={field.value === 99}
              prefixCls='checkbox-scale'
              onChange={(e) => {
                if (e.target.checked) setValue(`${question.id}.answer_uuid`, 99)
              }}
            >
              Затрудняюсь ответить
            </Checkbox>
          )}
        />
      )}
    </Flex>
  )
}

export default ScaleQuestion
